"use strict"

exports.TextEncoder = TextEncoder
exports.TextDecoder = TextDecoder
